




import { Vue, Component } from 'vue-property-decorator';
import { getRules } from './api/api';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo } from '@/common/ts/common';
@Component
export default class Rules extends Vue {
  rules: any = '';
  created() {
    getRules().then((res: any) => (this.rules = res.data));
    autoOpenApp();
    // 分享
    appShare({
      title: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      url: window.location.href,
      subtitle: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      subtitle: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
